'use client';

import { motion } from 'motion/react';

interface AuthShellProps {
  children: React.ReactNode;
}

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background">
      <div className="-translate-y-[10%] w-full max-w-[400px]">
        {/* Wordmark */}
        <p className="mb-8 font-serif text-xl font-semibold text-foreground">
          Supe.Market
        </p>

        {/* Form card with entry animation */}
        <motion.div
          className="w-full max-w-[calc(100vw-2rem)] rounded-xl border border-border bg-card p-8 shadow-xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
}
